import { TeaserTile } from 'components/TeaserBlurb';

export function ApiTeaser() {
  return (
    <TeaserTile
      imgSrc="/illustrations/ModulesTechnicalFoundation.svg"
      tickLineIds={['pro-api-teaser.line.1', 'pro-api-teaser.line.2', 'pro-api-teaser.line.3']}
    />
  );
}
